import { render, staticRenderFns } from "./verifyItems.vue?vue&type=template&id=2043c14b&scoped=true&"
import script from "./verifyItems.vue?vue&type=script&lang=js&"
export * from "./verifyItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043c14b",
  null
  
)

export default component.exports